<template>
    <el-dialog
    :visible="true"
    :title="title"
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="false"
    center
    custom-class="codelab-popper account-info-popper"
    width="400px"
    >
    <template v-if="mode === 0">
        <div class="user-infomation">
            <div class="info-item">
                <small>{{$t("account.name")}}</small>
                <p>{{userInfo.name}}</p>
            </div>
            <div class="info-item">
                <small>{{$t("account.number")}}</small>
                <p>{{userInfo.account}}</p>
            </div>
            <div class="info-item">
                <small>{{$t("account.password")}}</small>
                <p>
                    <span class="pass-dot" v-for=" i in 8" :key="i"></span>
                </p>
            </div>
        </div>
        <div slot="footer" class="footer-button-group">
            <button class="popper-footer-button codelab-button gray" @click="onClose">{{$t("button.close")}}</button>
            <button class="popper-footer-button codelab-button gray" @click="mode = 1">{{$t("button.change_pass")}}</button>
        </div>
    </template>
    <template v-else>
        <el-form class="codelab-form" @submit.prevent.native>
            <p class="form-label">{{$t('placeholder.input_old_pass')}}</p>
            <el-form-item>
                <password-input ref="oldPassInput" v-model="oldPassword" :show-visible="true" :error="oldPassError" @focus="oldPassError = false" @blur="checkNewPassEquel"></password-input>
                <p v-if="oldPassError" class="form-error">{{$t("message.error_old_pass")}}</p>
            </el-form-item>
            <p class="form-label">{{$t('placeholder.input_new_pass')}}</p>
            <el-form-item class="no-padding">
                <password-input v-model="password1" :show-visible="true" @blur="checkNewPassEquel" @focus="newPassEquel = true"></password-input>
            </el-form-item>
            <el-form-item>
                <password-input v-model="password2" :show-visible="true" :error="!newPassEquel" @blur="checkNewPassEquel" @focus="newPassEquel = true"></password-input>
                <p v-if="!newPassEquel" class="form-error">{{$t("message.error_new_pass_not_equel")}}</p>
            </el-form-item>
        </el-form>
        <div slot="footer" class="footer-button-group">
            <button class="popper-footer-button codelab-button gray" @click="onClose">{{$t("button.cancel")}}</button>
            <button class="popper-footer-button codelab-button blue" :class="{disabled: !validated}" @click="confirm">{{$t("button.change")}}</button>
        </div>
    </template>
    </el-dialog>
</template>
<script>
import passwordInput from '@/code-lab/view/password-input.vue'
import { mapState } from 'vuex'
const protocol = window.location.protocol
const passwordUrl = protocol + '//' + process.env.VUE_APP_changePassUrl
export default {
    name: 'accout-info',
    components: {
        passwordInput
    },
    props: {
        visible: Boolean
    },
    data () {
        return {
            mode: 0, // 0-展示帳號信息，1-修改密碼
            oldPassword: '',
            password1: '',
            password2: '',
            oldPassError: true,
            newPassEquel: true
        }
    },
    computed: {
        ...mapState('user', [
            'userInfo',
            'token'
        ]),
        title () {
            const titles = [
                this.$t('account.infomation'),
                this.$t('button.change_pass')
            ]
            return titles[this.mode]
        },
        validated () {
            return this.oldPassword && this.password1 && this.password1 === this.password2
        }
    },
    watch: {
        mode (value) {
            if (value === 1) {
                this.$nextTick(() => {
                    this.$refs.oldPassInput && this.$refs.oldPassInput.$el.querySelector('input').focus()
                })
            }
        }
    },
    methods: {
        onClose () {
            this.$emit('update:visible', false)
        },
        changePass () {
            return new Promise((resolve, reject) => {
                var xhr = new XMLHttpRequest()
                xhr.open('PUT', passwordUrl)
                xhr.setRequestHeader('authorization', 'Bearer ' + this.token)
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            let res = JSON.parse(xhr.response)
                            res.data.userId = res.data.userId || res.data.studentId
                            resolve(res.data)
                        } else {
                            let res = JSON.parse(xhr.response)
                            reject(res)
                        }
                    }
                }
                const formData = new FormData()
                formData.append('password', this.password1)
                formData.append('oldPassword', this.oldPassword)
                xhr.send(formData)
            })
        },
        checkNewPassEquel () {
            if (!this.password1 || !this.password2) {
                this.newPassEquel = true
                return
            }
            this.newPassEquel = this.password1 && this.password1 === this.password2
        },
        confirm () {
            if (this.validated) {
                this.newPassEquel = true
                this.oldPassError = false
                this.changePass().then(() => {
                    this.$message.success(this.$t('message.success_change_pass'))
                    this.onClose()
                }).catch(err => {
                    if (err.status.code === '10002') {
                        this.oldPassError = true
                    } else {
                        this.$message.error(this.$t('message.error_change_pass'))
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss">
.account-info-popper{
    .user-infomation{
        .info-item{
            margin-top: 18px;
            small{
                font-size: 14px;
                color: #c8c8c8;
                line-height: 22px;
            }
            p{
                font-size: 16px;
                color: #ffffff;
                line-height: 32px;
                letter-spacing: 0.12em;
            }
        }
    }
    .pass-dot{
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #ffffff;
        margin-left: 4px;
    }
    .form-label{
        font-size: 14px;
        color: #c8c8c8;
        line-height: 32px;
    }
    .el-form-item{
        margin-bottom: 0px;
        &.no-padding{
            .el-form-item__content{
                padding-bottom: 0;
            }
        }
        .el-form-item__content{
            position: relative;
            padding-bottom: 18px;
            .form-error{
                position: absolute;
                width: 100%;
                bottom: 10px;
                left: 0px;
                color: #fd5c53;
                font-size: 12px;
                line-height: 14px;
            }
        }
    }

}
</style>
